import React, {useContext, useEffect}  from 'react';
import { Switch, Route, Redirect } from "react-router-dom";

import Layout from "./layouts/Layout";
import Home from "./pages/Home"
import Profile from "./pages/Profile"
import SalarySettlement from "./pages/SalarySettlement"
import Benefits from './pages/Benefits'
import Vacations from './pages/Vacations'
import CertificateSerniority from './pages/CertificateSerniority'

import UserState from './context/User/UserState';
import BenefitsState from './context/Benefits/BenefitsState';
import SalarySettlementState from './context/SalarySettlement/SalarySettlementState';
import VacationState from './context/Vacation/VacationState';

import ComplementContext from "./context/Complement/ComplementContext"

import Loading from './components/Loading';
import RouterAdmin  from "./RouterAdmin.js";

const AppRouter  = ({path, isAdmin}) => {
    const complementContext = useContext(ComplementContext);
    const {loading, loadComplement} = complementContext;  

    useEffect(() => {        
        const load = () => {
            loadComplement();
        }
        load();
         // eslint-disable-next-line
    }, [])    
    
    return (
        <>
        <Redirect to="/" />
        {loading ? 
            <Loading /> :
            <UserState>
                <BenefitsState>
                    <Layout isAdmin={isAdmin}>        
                        <Switch>
                            <Route  exact path="/" component={Home} />
                            <Route exact path="/home" component={Home} />  
                            <Route exact path="/profile" component={Profile} />
                            <Route exact path="/certificate/seniority" component={CertificateSerniority} />
                            <Route exact path="/salarySettlement" > 
                                <SalarySettlementState> <SalarySettlement/> </SalarySettlementState>
                            </Route>
                            <Route exact path="/benefits" component={Benefits} />
                            <Route exact path="/vacations">
                                <VacationState> <Vacations/></VacationState>
                            </Route>
                                                    
                        </Switch>
                        {isAdmin ? <RouterAdmin /> : null}      
                        
                    </Layout>                    
                </BenefitsState>
            </UserState>
        }
        </>
    )
}

export default AppRouter ;